import StoredLayout from '../../layouts/StoredLayout'
import Faq from './Faq'
export default StoredLayout(Faq)



// WEBPACK FOOTER //
// ./src/documentation/faq/index.js